<template>
  <div :class="snackbar.modal && snackbar.message ? 'snackbar-overlay show ' + snackbar.type : 'snackbar-overlay hide'">
    <div class="snackbar-container">
      <p v-html="snackbar.message"></p>
      <span class="close" @click="closeModal()">X</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { setTimeout } from 'timers';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      snackbar: "snackbar/obj"
    })
  },
  watch: {
    snackbar(val) {
      if(val.modal == true){
        const self = this;
        setTimeout(() => {
          self.closeModal()
        }, val.time )
      } 
    }
  },
  mounted() {
    if(this.snackbar.modal == true){
      this.closeModal();
    }
  },
  methods: {
    closeModal() {
      this.closeSnackbar()
    },
    ...mapActions({
      closeSnackbar: "snackbar/closeSnackbar",
      setSnackbar: "snackbar/setSnackbar"
    })
  },
};
</script>

<style scoped>
.snackbar-overlay {
    position: fixed;
    right: 0px;
    left: 0px;
    bottom: -100%;
    margin: 0 auto;
    width: 320px;
    border-radius: 7px;
    padding: 15px 16px;
    transition: 0.4s ease-in-out;
    -moz-transition: 0.4s ease-in-out;
    -webkit-transition: 0.4s ease-in-out;
    z-index: 9999;
}
.snackbar-overlay.hide {
    bottom: -100%;
    transition: 0.4s ease-in-out;
    -moz-transition: 0.4s ease-in-out;
    -webkit-transition: 0.4s ease-in-out;
}
.snackbar-overlay.show{
   bottom: 10px;
  transition: 0.4s ease-in-out;
  -moz-transition: 0.4s ease-in-out;
  -webkit-transition: 0.4s ease-in-out;
}
  
.snackbar-overlay.success{
  background: #43d284
}
.snackbar-overlay.warning{
  background: red;
}
.snackbar-overlay.default{
  background: #8e8e8e;
}
.snackbar-overlay.show.info {
  background: #8e8e8e;
  color: #fff;
}
.snackbar-overlay p{
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 0px;
}
.snackbar-container {
  display: flex;
  flex-direction: column;
  padding-right: 40px;
  position: relative;
}
.snackbar-container .close {
    color: #fff;
    background: #000;
    font-size: 11px;
    border-radius: 50%;
    position: absolute;
    right: 6px;
    top: 50%;
    font-weight: 600;
    cursor: pointer;
    transform: translatey(-50%);
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 13px;
}
.snackbar-container .close:hover{
  opacity: 0.8;
}
@media only screen and (min-width: 1367px) {
  .snackbar-overlay {
    width: 400px;
  }
}
@media only screen and (max-width: 991px) {
  .snackbar-overlay {
    width: 400px;
  }
}
@media only screen and (max-width: 768px) {
 .snackbar-overlay {
    width: 320px;
  }
  .snackbar-overlay.show{
    bottom: 100px;
  }
}
</style>